// @module Eureka.MaxaPriceMatch.MaxaPriceMatch
define('Eureka.MaxaPriceMatch.MaxaPriceMatch.View'
    , [
        'eureka_maxapricematch_maxapricematch.tpl'

        , 'Eureka.MaxaPriceMatch.MaxaPriceMatch.SS2Model'
        , 'Profile.Model'

        , 'Backbone'
    ]
    , function (
        eureka_maxapricematch_maxapricematch_tpl
        , MaxaPriceMatchSS2Model
        , ProfileModel
        , Backbone
    ) {
        'use strict';

        // @class Eureka.MaxaPriceMatch.MaxaPriceMatch.View @extends Backbone.View
        return Backbone.View.extend({

            template: eureka_maxapricematch_maxapricematch_tpl

            , initialize: function (options) {
                this.profile = ProfileModel.getInstance()
                console.log("this.profile", this.profile)
                this.isLoggedIn = this.profile.attributes.isLoggedIn
                console.log("this.isLoggedIn", this.isLoggedIn)
                this.selectedFiles = [];
            }

            , events: {
                'click [data-action="submitButton"]': 'submitForm',
                'dragover #drag-and-drop-area': 'onDragOver',
                'dragleave #drag-and-drop-area': 'onDragLeave',
                'drop #drag-and-drop-area': 'onDrop',
                'click #drag-and-drop-area': 'onDragAreaClick',
                'change #file-input': 'onFileSelect',
                'change #my_file': 'onFileSelect',
                'click #get_file': 'clickLink'
            }

            , bindings: {}

            , childViews: {},

            onDragOver: function (e) {
                e.preventDefault();
                e.stopPropagation();
                this.$('#drag-and-drop-area').addClass('dragover');
            },

            onDragLeave: function (e) {
                e.preventDefault();
                e.stopPropagation();
                this.$('#drag-and-drop-area').removeClass('dragover');
            },

            onDrop: function (e) {
                e.preventDefault();
                e.stopPropagation();
                this.$('#drag-and-drop-area').removeClass('dragover');

                const files = e.originalEvent.dataTransfer.files;
                this.handleFiles(files);
            },

            clickLink: function (e) {
                document.getElementById('my_file').click();

            },


            onDragAreaClick: function (e) {
                document.getElementById('my_file').click();

            },

            onFileSelect: function (e) {
                const files = e.target.files;
                this.handleFiles(files);
            },

            handleFiles: function (files) {
                for (let i = 0; i < files.length; i++) {
                    const file = files[i];
                    this.selectedFiles = [file];
                    document.getElementById("file-list").innerHTML = `<p>${file.name}</p>`
                    console.log("this.selectedFiles", this.selectedFiles)
                }
                document.getElementById("filetypeError").style.display = "none"
                // Enable the submit button after files are added
                this.$('#submit-button').prop('disabled', this.selectedFiles.length === 0);
            },

            uploadFile: function (file) {
                const formData = new FormData();
                formData.append('file', file);
                console.log("file", file)
            },

            validateData: function (file, compName, isLoggedin){
                let isValid = true;
                if(file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf') {
                    document.getElementById("filetypeError").style.display = "none"
                }else{
                    document.getElementById("filetypeError").style.display = ""
                    isValid = false;
                }

                if(compName === ""){
                    document.getElementById("compNameError").style.display = ""
                    isValid = false;
                }else{
                    document.getElementById("compNameError").style.display = "none"
                }

                if(isLoggedin){
                    let email = document.getElementById('email').value

                    if(email === ""){
                        document.getElementById("emailError").style.display = ""
                        isValid = false;
                    }else{
                        document.getElementById("emailError").style.display = "none"
                    }

                    let phone = document.getElementById('phone').value

                    if(phone === ""){
                        document.getElementById("phoneError").style.display = ""
                        isValid = false;
                    }else{
                        document.getElementById("phoneError").style.display = "none"
                    }
                }
                return isValid;
            }

            , submitForm: function submitForm() {
                console.log("this.selectedFiles", this.selectedFiles);
                let compName = document.getElementById('compName').value
                let isLoggedin = this.isLoggedIn === "T"
                let file = this.selectedFiles[0]
                if(this.validateData(file, compName, isLoggedin)) {
                    let self = this
                    var reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = function () {
                        console.log("reader", reader)
                        let fileObject = {
                            value: reader.result,
                            fileName: file.name,
                            type: file.type,
                            loggedInUser: (isLoggedin) ? self.profile.attributes.email : document.getElementById('email').value,
                            phone: (isLoggedin) ? self.profile.attributes.phone : document.getElementById('phone').value,
                            competitorName: compName
                        };
                        let model = new MaxaPriceMatchSS2Model();
                        console.log("fileObject", fileObject);
                        model.fetch({type: "post", data: fileObject}).done(function (result) {
                            if (result.success) {
                                document.getElementsByClassName('pm-success-block')[0].style.display = ""
                                document.getElementsByClassName('pm-upload-block')[0].style.display = "none"
                            }
                        });
                    }
                }else {
                    return false;
                }
            }

            //@method getContext @return Eureka.MaxaPriceMatch.MaxaPriceMatch.View.Context
            , getContext: function getContext() {
                console.log(this.isLoggedIn)
                return {
                    notLoggedIn: this.isLoggedIn === "F"
                };
            }
        });
    });
